import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import OrderConfirmation from "./pages/OrderConfirmation";
import AuthCallback from "./pages/AuthCallback";
import Orders from "./pages/Orders";
import Admin from "./pages/Admin";
import AdminOrders from "./pages/AdminOrders";

function Router() {
  const location = useLocation();
  // Handle OAuth session_id in URL fragment BEFORE normal routing to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/menu" element={<Menu />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/order/:orderId" element={<OrderConfirmation />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/orders" element={<AdminOrders />} />
    </Routes>
  );
}

function Footer() {
  const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_naija-eats-6/artifacts/gjad5l4b_ChopBoxCo%20Green%20Logo%20PNG.png";
  return (
    <footer className="border-t border-[#1A6B2E]/10 mt-16 bg-white/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src={LOGO} alt="Chop Box Co." className="w-10 h-10" />
          <div className="leading-tight">
            <p className="font-display text-lg text-[#1A6B2E]">CHOP BOX CO.</p>
            <p className="font-script text-sm text-[#D02030]">Small chops. Big flavour.</p>
          </div>
        </div>
        <div className="text-xs text-[#4E5C4F] md:text-right space-y-1">
          <p>Call / Text to order · <a href="tel:+12265525375" className="font-semibold text-[#1A6B2E]">+1 (226) 552-5375</a></p>
          <p>Free pickup in Hamilton & Brantford · Home delivery available</p>
          <p>© {new Date().getFullYear()} Chop Box Co. · Made with care. Made for you.</p>
        </div>
      </div>
    </footer>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Header />
            <Router />
            <CartDrawer />
            <Footer />
            <Toaster position="top-center" richColors closeButton />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
